function AndroidBadget() {
  return (
    <svg width={181} height={52} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M173.856 52H7.418c-3.66 0-6.657-2.927-6.657-6.5v-39C.76 2.927 3.758 0 7.418 0h166.438c3.66 0 6.657 2.927 6.657 6.5v39c0 3.573-2.997 6.5-6.657 6.5Z"
        fill="#000"
      />
      <path
        d="M173.856 1.042c3.082 0 5.59 2.449 5.59 5.458v39c0 3.01-2.508 5.458-5.59 5.458H7.418c-3.082 0-5.59-2.448-5.59-5.458v-39c0-3.01 2.508-5.458 5.59-5.458h166.438Zm0-1.042H7.418C3.758 0 .761 2.927.761 6.5v39c0 3.573 2.997 6.5 6.657 6.5h166.438c3.66 0 6.657-2.927 6.657-6.5v-39c0-3.573-2.997-6.5-6.657-6.5Z"
        fill="#A6A6A6"
      />
      <path
        d="M63.897 13.317c0 1.085-.333 1.955-.988 2.603-.754.769-1.736 1.156-2.94 1.156-1.15 0-2.132-.394-2.937-1.169-.808-.786-1.21-1.752-1.21-2.907s.402-2.12 1.21-2.9c.805-.782 1.787-1.175 2.937-1.175a4.27 4.27 0 0 1 1.64.33c.519.215.942.508 1.248.869l-.696.685c-.534-.615-1.261-.92-2.192-.92a3.09 3.09 0 0 0-2.183.864c-.611.578-.918 1.327-.918 2.247 0 .92.307 1.675.918 2.254.617.57 1.344.863 2.183.863.89 0 1.64-.293 2.23-.87.39-.381.611-.908.67-1.58h-2.9v-.94h3.868c.047.203.06.4.06.59ZM70.034 10.06H66.4v2.47h3.276v.94H66.4v2.47h3.634v.957h-4.662V9.103h4.662v.957ZM74.364 16.897h-1.028V10.06h-2.229v-.957h5.488v.957h-2.23v6.837ZM80.566 16.897V9.103h1.027v7.794h-1.027ZM86.145 16.897h-1.02V10.06h-2.237v-.957h5.494v.957h-2.237v6.837ZM98.77 15.894c-.786.788-1.762 1.182-2.925 1.182-1.17 0-2.146-.394-2.933-1.182-.785-.786-1.177-1.752-1.177-2.894 0-1.142.392-2.108 1.177-2.894.787-.788 1.763-1.181 2.933-1.181 1.157 0 2.132.393 2.92 1.187.791.793 1.183 1.752 1.183 2.888 0 1.142-.392 2.108-1.177 2.894Zm-5.097-.653c.592.583 1.313.876 2.172.876.852 0 1.58-.293 2.165-.876.591-.583.89-1.333.89-2.241 0-.908-.299-1.658-.89-2.24-.586-.584-1.313-.877-2.165-.877-.859 0-1.58.293-2.172.876-.591.583-.89 1.333-.89 2.241 0 .908.299 1.658.89 2.24ZM101.391 16.897V9.103h1.248l3.881 6.062h.045l-.045-1.499V9.103h1.027v7.794h-1.072l-4.064-6.36h-.045l.045 1.504v4.856h-1.02Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.16}
        strokeMiterlimit={10}
      />
      <path
        d="M91.483 28.278c-3.128 0-5.683 2.324-5.683 5.53 0 3.18 2.555 5.528 5.683 5.528 3.133 0 5.688-2.348 5.688-5.528 0-3.206-2.555-5.53-5.689-5.53Zm0 8.88c-1.717 0-3.193-1.382-3.193-3.35 0-1.994 1.476-3.352 3.192-3.352 1.716 0 3.2 1.358 3.2 3.352 0 1.968-1.484 3.35-3.2 3.35Zm-12.398-8.88c-3.134 0-5.683 2.324-5.683 5.53 0 3.18 2.549 5.528 5.683 5.528 3.132 0 5.682-2.348 5.682-5.528 0-3.206-2.55-5.53-5.682-5.53Zm0 8.88c-1.718 0-3.2-1.382-3.2-3.35 0-1.994 1.482-3.352 3.2-3.352 1.716 0 3.192 1.358 3.192 3.352 0 1.968-1.477 3.35-3.192 3.35Zm-14.753-7.185v2.35h5.747c-.168 1.313-.618 2.278-1.307 2.95-.839.813-2.145 1.715-4.44 1.715-3.537 0-6.307-2.787-6.307-6.24 0-3.453 2.77-6.24 6.307-6.24 1.912 0 3.303.73 4.33 1.676l1.696-1.656c-1.436-1.34-3.347-2.368-6.026-2.368-4.85 0-8.926 3.853-8.926 8.588 0 4.735 4.076 8.588 8.926 8.588 2.621 0 4.59-.838 6.138-2.411 1.586-1.549 2.08-3.726 2.08-5.484a7.68 7.68 0 0 0-.13-1.468h-8.088Zm60.327 1.822c-.468-1.237-1.911-3.517-4.85-3.517-2.913 0-5.338 2.241-5.338 5.53 0 3.097 2.4 5.528 5.617 5.528a5.643 5.643 0 0 0 4.72-2.45l-1.93-1.256c-.644.92-1.522 1.529-2.79 1.529-1.26 0-2.164-.564-2.743-1.675l7.575-3.06-.261-.63Zm-7.723 1.84a3.067 3.067 0 0 1 2.957-3.223c.989 0 1.828.483 2.107 1.173l-5.064 2.05ZM110.779 39h2.49V22.75h-2.49V39Zm-4.077-9.49h-.084c-.559-.647-1.626-1.232-2.977-1.232-2.836 0-5.43 2.431-5.43 5.548 0 3.099 2.594 5.51 5.43 5.51 1.351 0 2.418-.59 2.977-1.256h.084v.793c0 2.114-1.157 3.25-3.023 3.25-1.521 0-2.465-1.072-2.854-1.974l-2.166.882c.624 1.466 2.277 3.27 5.02 3.27 2.919 0 5.383-1.677 5.383-5.758v-9.928h-2.36v.895Zm-2.848 7.649c-1.716 0-3.153-1.402-3.153-3.333 0-1.948 1.437-3.37 3.153-3.37 1.691 0 3.024 1.422 3.024 3.37 0 1.93-1.333 3.333-3.024 3.333Zm32.462-14.409h-5.955V39h2.483v-6.157h3.472c2.758 0 5.462-1.949 5.462-5.047s-2.711-5.046-5.462-5.046Zm.065 7.832h-3.537V25.01h3.537a2.853 2.853 0 0 1 2.912 2.786c0 1.257-1.058 2.787-2.912 2.787Zm15.35-2.335c-1.794 0-3.66.774-4.427 2.488l2.204.902c.474-.902 1.346-1.194 2.268-1.194 1.288 0 2.595.755 2.615 2.09v.17c-.449-.253-1.411-.629-2.595-.629-2.373 0-4.792 1.276-4.792 3.657 0 2.177 1.944 3.58 4.13 3.58 1.671 0 2.593-.737 3.172-1.593h.085v1.256h2.398v-6.233c0-2.882-2.203-4.494-5.058-4.494Zm-.299 8.905c-.813 0-1.944-.393-1.944-1.376 0-1.258 1.411-1.74 2.633-1.74 1.093 0 1.606.235 2.27.546-.195 1.504-1.521 2.57-2.959 2.57Zm14.095-8.549-2.854 7.045h-.085l-2.951-7.045h-2.678l4.434 9.844-2.53 5.478h2.595l6.832-15.322h-2.763ZM143.143 39h2.49V22.75h-2.49V39Z"
        fill="#fff"
      />
      <path
        d="M14.655 9.8c-.391.4-.617 1.022-.617 1.829v28.749c0 .806.226 1.428.617 1.828l.097.088 16.5-16.104v-.38l-16.5-16.104-.097.094Z"
        fill="url(#a)"
      />
      <path
        d="m36.746 31.56-5.494-5.37v-.38l5.5-5.37.124.07 6.514 3.618c1.86 1.027 1.86 2.717 0 3.75l-6.514 3.613-.13.07Z"
        fill="url(#b)"
      />
      <path
        d="M36.876 31.49 31.252 26 14.655 42.206c.617.634 1.624.71 2.77.076l19.451-10.791"
        fill="url(#c)"
      />
      <path
        d="M36.876 20.51 17.424 9.716c-1.145-.627-2.152-.55-2.77.083L31.253 26l5.624-5.49Z"
        fill="url(#d)"
      />
      <defs>
        <linearGradient
          id="a"
          x1={29.787}
          y1={40.677}
          x2={7.976}
          y2={18.338}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset={0.007} stopColor="#00A1FF" />
          <stop offset={0.26} stopColor="#00BEFF" />
          <stop offset={0.512} stopColor="#00D2FF" />
          <stop offset={0.76} stopColor="#00DFFF" />
          <stop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="b"
          x1={45.811}
          y1={25.998}
          x2={13.593}
          y2={25.998}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset={0.409} stopColor="#FFBD00" />
          <stop offset={0.775} stopColor="orange" />
          <stop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="c"
          x1={33.818}
          y1={23.015}
          x2={4.241}
          y2={-7.279}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="d"
          x1={10.477}
          y1={51.771}
          x2={23.685}
          y2={38.243}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset={0.069} stopColor="#2DA771" />
          <stop offset={0.476} stopColor="#15CF74" />
          <stop offset={0.801} stopColor="#06E775" />
          <stop offset={1} stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export default AndroidBadget;
